import { render, staticRenderFns } from "./SvgPathTag.vue?vue&type=template&id=494b8980&scoped=true&"
import script from "./SvgPathTag.vue?vue&type=script&lang=js&"
export * from "./SvgPathTag.vue?vue&type=script&lang=js&"
import style0 from "./SvgPathTag.vue?vue&type=style&index=0&id=494b8980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b8980",
  null
  
)

export default component.exports